module.exports = __webpack_public_path__ + "img/spain.4a53804.webp";